import * as z from "zod";

import { maintenancePlanGroupSchema } from "./maintenance-plan-group";
import { maintenancePlanCodeSchema } from "./maintenance-plan-code";

export const maintenancePlanCodeWithGroupSchema =
  maintenancePlanCodeSchema.extend({
    maintenancePlanGroup: maintenancePlanGroupSchema,
  });

export type MaintenancePlanCodeWithGroup = z.infer<
  typeof maintenancePlanCodeWithGroupSchema
>;
